<template>
  <section class="homepage-banner" :class="[isDark ? 'dark-banner' : 'light-banner', { 'homepage-banner--transparent': isDiwaliActive }]">
    <div class="sub-container">
      <!-- Main Banner Badge -->
      <CommonBannerBadge text="Invest with Intent. Rize with Purpose." :color="colors.primaryText"
        :bgColor="colors.primaryBadge" :icon="mainBadgeIcon" />

      <!-- Heading -->
      <h2 id="main-heading" class="text-center">
        Build wealth with opportunities that reflect your goals and
        values
      </h2>

      <!-- Subtext -->
      <p class="text-center" :style="{ color: colors.secondaryText }">
        Choose from regulated options
      </p>

      <!-- Call-to-Action Button -->
      <CommonButton class="btn sign_up_initiated" text="Explore" :color="colors.buttonBg" width="150px" height="40px"
        :href="investEquirizeUrl" />

      <!-- Small Badges Section -->
      <div class="badge-section">
        <!-- <CommonBannerBadge
        image="/icons/lock.svg"
          text="Non-Market Linked"
          :color="colors.secondaryText"
          :bgColor="'transparent'"
        /> -->
        <CommonBannerBadge icon="<i class='mdi mdi-leaf' ></i>" text="Member with BSE & NSE"
          :color="colors.secondaryText" :bgColor="'transparent'" />
        <CommonBannerBadge :icon="mainBadgeIcon" text="Regulated" :color="colors.secondaryText"
          :bgColor="'transparent'" />
      </div>
    </div>
    <img :src="isDark ? '/images/hero-desktopDark.svg' : '/images/hero-bondBanner-desktop.webp'"
      class="img-fluid banner-img desktop-view" alt="Bonds investment opportunities" fetchpriority="high"
      />
    <img :src="isDark ? '/images/heroDark.svg' : '/images/heroBondMobileBanner.webp'"
      class="img-fluid banner-img mobile-view" alt="Bonds investment banner" fetchpriority="high"
      />
  </section>
</template>

<script setup>
import { computed } from "vue";
import { useTheme } from "~/composables/useTheme";
import { CommonButton, CommonBannerBadge } from "#components";
import { useUtmTracking } from "~/composables/useUtmTracking";
import { useRoute } from "vue-router";
import { useRuntimeConfig } from "#app";

const { colors, themeName } = useTheme();
const config = useRuntimeConfig();
const isDiwaliActive = computed(() => config.public.VITE_ENABLE_DIWALI_THEME === "true");
const isDark = computed(() => themeName.value === "dark");
const { buildRedirectUrl } = useUtmTracking();
const route = useRoute();
const { investorUrl } = useInvestorPlatform();

const investEquirizeUrl = computed(() => {
  return buildRedirectUrl(investorUrl("/login"), route.path, "explore-home-banner");
});

// Main banner SVG icon
const mainBadgeIcon = `<svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#0AA245">
  <path d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
  </svg>`;
</script>

<style scoped>
.homepage-banner--transparent {
  background-color: transparent !important;
  background-image: none !important;
}
section {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 100px 0 0 0;
  /* margin-bottom: 60px; */
}
#main-heading{
  font-size: 2.5rem;
}
.sub-container {
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 30px 26px;
}

.btn {
  margin-top: 30px;
}

.badge-section {
  margin-top: 18px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.banner-img {
  margin-top: auto;
  width: 100%;
}

@media (max-width: 1024px) {
  .sub-container {
    width: 95%;
  }
}

@media (min-width: 1024px) {
  section {
    /* min-height: 600px; */
  }

  .badge-section {
    gap: 20px;
  }

  .banner-img {
    max-width: 1000px;
    width: auto;
  }
}

.sign_up_initiated {}
</style>
